/**
 * Deli homemade salads data
 * Represents homemade salads available by weight at the deli counter
 */

const deliHomemadeSalads = [
  {
    id: 1,
    name: "Our Famous Tuna Salad",
    category: "homemade-salads"
  },
  {
    id: 2,
    name: "Coleslaw",
    category: "homemade-salads"
  },
  {
    id: 3,
    name: "Potato Salad",
    category: "homemade-salads"
  },
  {
    id: 4,
    name: "Egg Salad",
    category: "homemade-salads"
  },
  {
    id: 5,
    name: "Chicken Salad",
    category: "homemade-salads"
  },
  {
    id: 6,
    name: "Smoked Whitefish Salad",
    category: "homemade-salads"
  },
  {
    id: 7,
    name: "Smoked Salmon Salad",
    category: "homemade-salads"
  },
  {
    id: 8,
    name: "Fat Free Tuna Salad",
    category: "homemade-salads"
  },
  {
    id: 9,
    name: "Seafood Salad",
    category: "homemade-salads"
  },
  {
    id: 10,
    name: "Macaroni Salad",
    category: "homemade-salads"
  },
  {
    id: 11,
    name: "Greek Pasta",
    category: "homemade-salads"
  },
  {
    id: 12,
    name: "Tuna Pasta",
    category: "homemade-salads"
  },
  {
    id: 13,
    name: "Veggie Chopped Liver",
    description: "Contains Walnuts",
    category: "homemade-salads"
  },
  {
    id: 14,
    name: "Sour Cream & Cheddar Macaroni Salad",
    category: "homemade-salads"
  },
  {
    id: 15,
    name: "Pasta Primavera",
    category: "homemade-salads"
  }
];

module.exports = deliHomemadeSalads;